import { Command } from '@nest/internal-frontend';
import { Play } from 'lucide-react';

export const useCommandInboundDeliveryOrderStartProcess = ({
	inboundDeliveryOrder,
	startProcessingMutation
}: {
	inboundDeliveryOrder: { id: number; state: string; assignedTo?: { id: number } } | undefined;
	startProcessingMutation: { mutate: (id: number) => void; isPending: boolean };
}): Command => {
	const isCreated = inboundDeliveryOrder?.state === 'Created';
	const isInProgress = inboundDeliveryOrder?.state === 'InProgress';
	const isUnassigned = !inboundDeliveryOrder?.assignedTo;
	const canStart = Boolean((isCreated || (isInProgress && isUnassigned)) && inboundDeliveryOrder);

	return {
		id: 'start-processing',
		label: 'Zpracovat doklad',
		icon: <Play className="h-4 w-4" />,
		shortcut: undefined,
		disabled: !canStart || startProcessingMutation.isPending,
		loading: undefined,
		run: async () => {
			if (inboundDeliveryOrder) {
				startProcessingMutation.mutate(inboundDeliveryOrder.id);
			}
		}
	};
};
